/**
 * @file 财务模块相关的过滤器
 * @author malcolmmzma
 */

export default {
  cost_type: {
    name: 'cost_type',
    title: '消耗类型',
    type: 'select',
    config: {
      multiple: false,
      data: [
        { label: '竞价', value: '1' },
        { label: '合约', value: '2' },
        { label: '互选', value: '3' },
      ],
    },
    clearable: true,
  },
};
